import { makeStyles, createStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles(() =>
    createStyles({
      box: {
        flex: 'none',
        height: '30px',
        background: 'transparent'
      },
      attractSubheader: {
        fontSize: '50px',
        fontWeight: 800
      },
      inactiveHeader: {
        fontSize: '64px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        fontWeight: 900,
        margin: '0px',
        lineHeight: '1.25',
        whiteSpace: 'pre-wrap'
      },
      inactiveSubheader: {
        fontSize: '32px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        textTransform: 'none',
        whiteSpace: 'pre-wrap'
      }
    })
  );
